import React from "react";

export const isPastTrip = (trip) => {
  const [day, month, year] = trip.date.split("/").map(Number);
  const [hours, minutes] = trip.time.split(":").map(Number);
  const tripDateTime = new Date(year, month - 1, day, hours, minutes);

  return tripDateTime < new Date();
};

export const getTripStatusUi = (trip) => {
  const isCancelled = trip.status.startsWith("Cancelled - ");
  const isRefused = trip.status.startsWith("Refused - ");
  const isUnallocated = trip.status.startsWith("Pending...");
  const isVolCar = trip.status.startsWith("Booked - ");
  const undoCancel = trip.cancellationStatus === 4;
  const pastTrip = isPastTrip(trip);

  let quickStatus = trip.status;
  let tabText = "";
  let tabColor = "#000";

  if (isUnallocated) {
    tabColor = "#FFBF00";
    tabText = "Pending...";
  }

  if (isCancelled) {
    tabColor = "#b90101ff";
    tabText = "Cancelled";
  }

  if (isRefused) {
    tabColor = "#b90101ff";
    tabText = "Refused";
  }

  if (!isUnallocated && !isCancelled && !isRefused) {
    tabColor = "#009c00ff";
    tabText = isVolCar ? (
      <i className="fa-solid fa-car-side" style={{ color: "white" }} />
    ) : (
      <i className="fa-solid fa-bus" style={{ color: "white" }} />
    );
  }

  if (undoCancel) {
    tabColor = "#FFBF00";
    tabText = <span>Pending Cancel...</span>;
  }

  if (pastTrip) {
    quickStatus = "Past - " + quickStatus;
  }

  return {
    isCancelled,
    isRefused,
    isUnallocated,
    isVolCar,
    undoCancel,
    isPastTrip: pastTrip,
    quickStatus,
    tabText,
    tabColor,
  };
};

export const sortTripsByDateTime = (trips) =>
  [...trips].sort((a, b) => {
    const dateA = new Date(`${a.date}T${a.time}`);
    const dateB = new Date(`${b.date}T${b.time}`);
    return dateA - dateB;
  });
